import { Button } from '@/components/ui/button';
import CategoryButtons from './category-buttons';
import { HorizontalBadgeScroll } from './horizontal-badge-scroll';
import ItemCard from './menu-item';
import { Grid, List } from 'lucide-react';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import MenuListItem from './menu-item-card';
import { useIsMobile } from '@/hooks/use-mobile';

export default function MenuListing({
    menuItems,
    categories,
    types,
}: {
    menuItems: App.Data.MenuItemData[];
    categories: App.Data.CategoryData[];
    types: App.Data.MenuItemTypeData[];
}) {
    const [view, setView] = useState<'grid' | 'list'>('grid');

    const isMobile = useIsMobile();

    useEffect(() => {
        if (isMobile) {
            setView('list');
        }
    }, [isMobile]);
    return (
        <div className="container pb-12">
            {/* Category Buttons */}
            <div className="sticky top-0 z-50 bg-background py-4">
                <div className="border-b border-primary/20">
                    <CategoryButtons categories={types} />
                </div>

                {/* Subcategory Horizontal Scroll */}
                <HorizontalBadgeScroll
                    items={categories.map((category) => ({
                        id: category.id,
                        name: category.name,
                        slug: category.slug,
                    }))}
                />
            </div>
            {
                !isMobile && (
                    <div className="mt-4 flex items-center justify-end gap-1">
                        <Button variant={view === 'grid' ? 'default' : 'secondary'} size="sm" onClick={() => setView('grid')}>
                            <Grid className="size-4" />
                            <span className="sr-only">Grid View</span>
                        </Button>
                        <Button variant={view === 'list' ? 'default' : 'outline'} size="sm" onClick={() => setView('list')}>
                            <List className="size-4" />
                            <span className="sr-only">List View</span>
                        </Button>
                    </div>

                )
            }
            {/* Items Grid */}
            <div className={cn('mt-2 grid gap-6', {
                'grid-cols-1': view === 'list',
                'grid-cols-1 md:grid-cols-2 lg:grid-cols-3': view === 'grid',
            })}>
                {menuItems.length > 0 ? (
                    menuItems.map((item) => (
                        view === 'grid' ? (
                            <ItemCard key={item.id} item={item} />
                        ) : (
                            <MenuListItem key={item.id} item={item} />
                        )
                    ))
                ) : (
                    <p className="col-span-full py-12 text-center text-muted-foreground">
                        No items found for this selection.
                    </p>
                )}
            </div>
        </div>
    );
}
